import React from "react";
import AboutFeatureSection from "../Sections/AboutFeatureSection";
import AboutValuesSection from "../Sections/AboutValuesSection";
import "./AboutPhilosophySection.css";

interface FeaturePoint {
  title: string;
  description?: string;
}

interface AboutStatementProps {
  tag: string;
  icon?: React.ReactNode;
  title: string;
  highlighted: string;
  description: string;
  points: FeaturePoint[];
}

interface AboutValuesProps {
  tag: string;
  icon?: React.ReactNode;
  values: { title: string; description: string }[];
}

interface AboutPhilosophySectionProps {
  mission: AboutStatementProps;
  vision: AboutStatementProps;
  values: AboutStatementProps | AboutValuesProps; // ✅ can be either
  rightImages?: string[];
}

const AboutPhilosophySection: React.FC<AboutPhilosophySectionProps> = ({
  mission,
  vision,
  values,
  rightImages = [],
}) => {
  // ✅ check if `values` contains a "values" array (AboutValuesSection style)
  const isValuesBlock = (obj: any): obj is AboutValuesProps => "values" in obj;

  return (
    <section className="about-philosophy-section">
      <div className="philosophy-left">
        <AboutFeatureSection {...mission} />
        <AboutFeatureSection {...vision} />
        {isValuesBlock(values) ? (
          <AboutValuesSection {...values} />
        ) : (
          <AboutFeatureSection {...(values as AboutStatementProps)} />
        )}
      </div>

      <div className="philosophy-right">
        {rightImages?.map((src, index) => (
          <img
            key={index}
            src={src}
            alt={`Philosophy Visual ${index + 1}`}
            className={`philosophy-image ${index === 0 ? "top" : "bottom"}`}
          />
        ))}
      </div>
    </section>
  );
};

export default AboutPhilosophySection;
